"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayDockContext = void 0;
const React = require("react");
/**
 * Invoke the ability to set a PayDock card.
 */
exports.PayDockContext = React.createContext({
    gatewayId: undefined,
    prefillData: undefined,
    error: undefined,
    isLoading: undefined,
    refetch: undefined
});
//# sourceMappingURL=index.js.map